import DatePicker from "react-date-picker";

import React from "react";
import { Grid } from "semantic-ui-react";

const Dob = ({ getDob, dob }) => {
  return (
    <Grid.Column mobile={16} tablet={8} computer={8}>
      <div className="form-group">
        <label htmlFor="dob">
          Date of Birth <span className="required">*</span>
        </label>
        <DatePicker
          id="sdate"
          className="cu-datepicker"
          value={dob}
          onChange={getDob}
          placeholderText="Select start date"
        />
      </div>
    </Grid.Column>
  );
};

export default Dob;
